import { Injectable } from '@angular/core';
import { IParameters } from '@interfaces/parameters.interface';
import { ParametersService } from '@services/apis/parameters/parameters.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  public token = new Subject<string>();
  public authorizations: IParameters[] = [];
  public vehicleReception: IParameters[] = [];
  constructor(public parametersService: ParametersService) { }
  public getCurrentToken(): Observable<string> {
    return this.token.asObservable();
  }

  public setToken(token: string) {
    this.token.next(token);
  }

  public getParameters() {
    this.parametersService.getAllAuthorizations().subscribe(
      data => this.authorizations = data
    )
    this.parametersService.getAllVehicleReception().subscribe(
      data => this.vehicleReception = data
    )
  }

  getAuthorizations() {
    return this.authorizations;
  }
  getVehicleReception() {
    return this.vehicleReception;
  }
}

